import { getPath } from '../utils/Router';
import query from './query';
import lct from './location';

export const buildUiUrl = (keyOrPath, params, searchObject) => {
  const pathname = getPath(keyOrPath, params);
  if (!searchObject) return pathname;
  const qs = new URLSearchParams(query.stringify({ ...searchObject })).toString();
  return qs ? `${pathname}?${qs}` : pathname;
};

export const buildApiUrl = (base, path, params) => {
  let p = String(path || '').replace(/^undefined/, '');
  if (!p.startsWith('/')) p = `/${p}`;
  const qs = params ? lct.stringify(params) : '';
  return qs ? `${base}${p}?${qs}` : `${base}${p}`;
};

export default {
  buildUiUrl,
  buildApiUrl,
};


